import React, { Component } from 'react';
var classNames = require('classnames');

class UserInput extends Component{
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    var value = e.target.value;
    if(value === ''){
      value = 0
    }
    const name = this.props.name;
    this.props.onChange(value, name, this.props.step);
  }

  
  render() {
    const styles = this.props.styles;
    const separator = (this.props.currency !== undefined && this.props.unitInfo ) ? " / " : "";

    return(
      <div ref="section" className={classNames(styles.inputItem, styles.inputColour)}>
        <div className={styles.info}>
          {this.props.description}
        </div>
        <p>{this.props.helpText}</p>
        <input
          className={styles.inputField}
          type="number"
          //defaultValue={parseFloat(this.props.value).toFixed(2)}
          value={this.props.value}
          name={this.props.name}
          onChange={this.handleChange}
        />
        <span>
          {this.props.currency !== undefined && this.props.currency.symbol} {separator} {this.props.unitInfo}
        </span>
      </div>
    );
  }
}

export default UserInput;



// WEBPACK FOOTER //
// ./src/components/calculator/step-by-step/s_user_input.js